const getSessionVO = () => {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    return {
        "appType": "web",
        "deviceMacId": "",
        "keepMeLoggedInFlag": keepMeLogIn,
        "deviceOS": localStorage.getItem('deviceOS'),
        "deviceType": localStorage.getItem('deviceType'),
        "browserName": localStorage.getItem('browserName'),
        "sessionAuthenticationToken": userVO.sessionAuthenticationToken
    }
}
const getUserVO = (lastActivCode) => {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    return {
        "userId": userVO.userId,
        "schoolId": userVO.schoolId,
        "userRole": userVO.userRole,
        "userRoleId": userVO.userRoleId,
        "keepMeLoggedInFlag": keepMeLogIn,
        "userActivityVO": {
            "lastReadBookId": "",
            "lastReadPageNum": "",
            "lastReadChapterId": "",
            "lastReadSectionId": "",
            "lastReadParagraphId": "",
            "lastViewedOutlineId": "",
            "lastReadSubSectionId": "",
            "pageNavigatingFrom": "EReader",
            "pageNavigatingTo": "Bookshelf",
            "lastActivityCode": lastActivCode ? lastActivCode : "BOOKSHELF",
        },
        "sessionVO": getSessionVO(),
    }
}
export const post = (url, data = {}, type, activityCode) => {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const authToken = userVO.apJwtAuthenticationToken ? userVO.apJwtAuthenticationToken : localStorage.getItem('apJwtAuthenticationToken');
    let preReqPayload = { "userVO": getUserVO(activityCode) }
    let reqPayload = { ...preReqPayload, ...data }
    const requestOptions = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify(reqPayload)
    };
    switch (type) {
        case 'ENV':
            delete requestOptions.headers.Authorization;
            break;
        default:
            break;
    }
    return fetch(localStorage.getItem(type) + url, requestOptions);
};
export const put = (url, data = {}, type, activityCode) => {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const authToken = userVO.apJwtAuthenticationToken ? userVO.apJwtAuthenticationToken : localStorage.getItem('apJwtAuthenticationToken');
    let preReqPayload = { "userVO": getUserVO(activityCode) }
    let reqPayload = { ...preReqPayload, ...data }
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify(reqPayload)
    };
    switch (type) {
        case 'ENV':
            delete requestOptions.headers.Authorization;
            break;
        default:
            break;
    }
    return fetch(localStorage.getItem(type) + url, requestOptions);
};
export const get = (url, type) => {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const authToken = userVO.apJwtAuthenticationToken ? userVO.apJwtAuthenticationToken : localStorage.getItem('apJwtAuthenticationToken');
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const requestOptions = {
        method: 'GET',
        headers: {
            'userId': userVO.userId,
            'Accept': 'application/json',
            'keepMeLoggedInFlag': keepMeLogIn,
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        }
    };
    switch (type) {
        case 'ENV':
            delete requestOptions.headers.Authorization;
            break;
        default:
            break;
    }
    return fetch(localStorage.getItem(type) + url, requestOptions);
}